export default "__VITE_ASSET__M9L8cDio__"